import faina from "./faina.jpg";
import hrisca from "./hrisca.jpg";
import orez from "./orez.jpg";

export default [
  {
    src: faina,
    origin: "Țara de origine - USA",
    text:
      "Făină de grâu este materia primă pentru prepararea pâinii și a altor specialități din aluat. Acest produs conține elemente necesare la prepararea  pâinii, printre care amidon, gluten, flor etc. Făina noastră este renumită anume pentru conținutul adecvat de astfel de elemente."
  },
  {
    src: hrisca,
    origin: "Țara de origine - Rusia",
    text:
      "Acest aliment este popular și tradițional în țări  precum Rusia, Ucraina, Franța, Moldova etc. Hrișca este bogată în vitaminele E, B1 și B2, dar și în proteine, carbohidrați, fibre, fosfor, magneziu, cupru, zinc, mangan, seleniu și fier."
  },
  {
    src: orez,
    origin: "Țara de origine - Egipt",
    text:
      "Orezul este una dintre cele mai vechi și populare cereale, un aliment preferat pe toate continentele.Spre livrare vă propunem orez brun, camolino și lung lustruit."
  }
];
